import store from './store';

export const items = () => {
  return [
    {
      name: 'Dashboard',
      url: '/admin/dashboard',
      icon: 'icon-layers',
    },
    {
      name: 'Projecten',
      url: '/admin/projects',
      icon: 'icon-globe-alt',
    },
    {
      name: 'Project introducties',
      url: '/admin/project-introductions',
      icon: 'icon-bubble',
    },
    {
      name: 'Nieuws',
      url: '/admin/news',
      icon: 'icon-globe-alt',
    },
    {
      name: 'Veelgestelde vragen',
      url: '/admin/faq',
      icon: 'icon-graduation',
    },
    {
      name: 'Accounts',
      url: '/base',
      icon: 'icon-people',
      children: [
        {
          name: 'SF Relaties',
          url: '/admin/accounts',
          icon: 'icon-people'
        },
        {
          name: 'SF Contactpersonen',
          url: '/admin/accounts/contacts',
          icon: 'icon-people'
        },
        {
          name: 'Portal Users',
          url: '/admin/portal-users',
          icon: 'icon-people'
        },
        {
          name: 'Groepen',
          url: '/admin/groups/Index',
          icon: 'icon-people',
        },
      ]
    },
// xxxx


// xxxx
    {
      name: 'Beheerders',
      url: '/admin/users',
      icon: 'icon-people',
    },
  ];
};
